/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Billingservicev2Invoice } from '../models/Billingservicev2Invoice';
import { HttpFile } from '../http/http';

/**
* ListInvoicesResponse
*/
export class Billingservicev2ListInvoicesResponse {
    /**
    * List of invoices
    */
    'invoices'?: Array<Billingservicev2Invoice>;
    /**
    * A token, which can be sent as `page_token` to retrieve the next page. If this field is omitted, there are no subsequent pages.
    */
    'nextPageToken'?: string;
    /**
    * The total count of creatives irrespective of pagination. If filtering is used, the `total_size` field reflects the total count of creatives after the filter is applied.
    */
    'totalSize'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "invoices",
            "baseName": "invoices",
            "type": "Array<Billingservicev2Invoice>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "next_page_token",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalSize",
            "baseName": "total_size",
            "type": "number",
            "format": "int32"
        }    ];

    static getAttributeTypeMap() {
        return Billingservicev2ListInvoicesResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

